import React from 'react';

import styles from './Header.m.sass';

import withMediaQueries from '../../containers/withMediaQueries/withMediaQueries';
import {Link} from 'react-router';
import SearchBarContainer from "../searchBarContainer/SearchBarContainer";
import TrustPilotInline from '../trustPilot/TrustPilotInline';

import CartIcon from '-!svg-react-loader?name=CartIcon!./assets/cart.svg';
import arrowRightIcon from '../../components/button/assets/arrow-right-accent.svg';
import MenuIcon from '-!svg-react-loader?name=MenuIcon!./assets/menu.svg';
import HeaderSideMenu from './HeaderSideMenu';
import RoundSocials from '../roundSocials/RoundSocials';
import RoundButton from "../roundButton/RoundButton";
import ChannelDropdown from '../../containers/channelUtils/ChannelDropdown';
import Logo from '../logo/Logo';

@withMediaQueries({collapsed: '(max-width: 991px)'}, {collapsed: false})
export default class Header extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {isMenuOpen: false};
  }

  componentDidUpdate(prevProps) {
    const {location} = this.props;

    if (location !== prevProps.location) {
      this.setState({isMenuOpen: false});
    }
  }

  render() {
    const {collapsed, cartItemCount, onCartClick, menu} = this.props;

    return (
      <header className={styles.header}>
        <div className="container">
          <div className={styles.row}>
            <div className={styles.left}>
              {!collapsed && (
                <div className={styles.leftTop}>
                  <nav className={styles.links}>
                    {menu && menu.map(({name, page, code}, idx) => (
                      <Link
                        key={code || idx}
                        className={styles.link}
                        to={`/page/${page.slug}`}
                      >
                        {name}
                      </Link>
                    ))}
                  </nav>

                  <div className={styles.contacts}>
                    <button className={styles.contactUs}>
                      <span className={styles.contactUsWrapper}>
                        <span className={styles.contactsUsText}>contact us</span>
                        <span className={styles.contactsUsArrow}>
                          <img src={arrowRightIcon} alt=""/>
                        </span>
                      </span>
                    </button>

                    <RoundSocials/>
                  </div>
                </div>
              )}

              <div className={styles.leftBottom}>
                {collapsed && (
                  <RoundButton
                    onClick={() => this.setState({isMenuOpen: true})}
                    accent
                  >
                    <MenuIcon/>
                  </RoundButton>
                )}

                {collapsed && (
                  <HeaderSideMenu
                    isOpen={this.state.isMenuOpen}
                    onStateChange={isMenuOpen => this.setState({isMenuOpen})}
                    cartItemCount={cartItemCount}
                  />
                )}

                <div className={styles.logo}>
                  <Logo/>
                </div>

                {!collapsed && (
                  <div className={styles.search}>
                    <SearchBarContainer/>
                  </div>
                )}
              </div>
            </div>

            <div className={styles.right}>
              <div className={styles.rightTop}>
                {!collapsed && <TrustPilotInline/>}
              </div>

              <div className={styles.rightBottom}>
                {!collapsed && <ChannelDropdown/>}

                <RoundButton onClick={onCartClick}>
                  <CartIcon/>

                  {!!cartItemCount && (
                    <span className={styles.cartCounter}>{cartItemCount}</span>
                  )}
                </RoundButton>

                {/* TODO: Implement when auth will be available */}
                {/*{!collapsed && (*/}
                {/*  <button className={styles.signIn}>*/}
                {/*    <span className={styles.signInIcon}/>*/}
                {/*    <span className={styles.signInText}>Sign in</span>*/}
                {/*  </button>*/}
                {/*)}*/}
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./components/header/Header.js